// extracted by mini-css-extract-plugin
export default {"container":"ExpandableText_container__rrMdA","text":"ExpandableText_text__ZLBln","toggleBtn":"ExpandableText_toggleBtn__9BNak"};